import { lazy } from 'react';
import { DISPUTE_PERMISSIONS } from './constants';

const DisputeListPage = lazy(() => import('./pages/DisputeListPage'));
const DisputeDetailPage = lazy(() => import('./pages/DisputeDetailPage'));
const ProblemTypesPage = lazy(() => import('./pages/ProblemTypesPage'));

export const disputeRoutes = [
  {
    path: '/disputes',
    element: DisputeListPage,
    permission: DISPUTE_PERMISSIONS.MEDIATE,
    nav: { labelKey: 'nav.disputes', icon: 'WarningOutlined', group: 'operations' },
  },
  {
    path: '/disputes/problem-types',
    element: ProblemTypesPage,
    permission: DISPUTE_PERMISSIONS.MEDIATE,
    nav: { labelKey: 'nav.disputeProblemTypes', icon: 'TagsOutlined', group: 'operations' },
  },
  { path: '/disputes/:id', element: DisputeDetailPage, permission: DISPUTE_PERMISSIONS.MEDIATE, nav: null },
];
